import { watchFetchSalesCompliance } from './fetchCompliance';

export const complianceSalesSagas = [watchFetchSalesCompliance()];
